import http from './http'

export default {
  passengerFlowMeter: {
    getList (search, pageConfig) {
      return http.get('/passengerflow/passengerflowmeter/getlist', {
        shopId: search.shopId,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    create (model) {
      return http.post('/passengerflow/passengerflowmeter/create', model)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/passengerFlow.js